<template>
    <div class="w-full">
        <template v-if="editMode">
            <div class="flex text-gray-600 text-sm px-4 items-start">
                <div class="pr-4 flex-grow-4">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">Beschreibung</label>
                    <input type="text" class="input w-full" v-model="invoiceItem.description"
                           placeholder="Beschreibung"/>
                    <div class="input-error-message" v-if="errors['description']">{{errors['description'][0]}}</div>
                    <div class="mt-1">
                      <input type="checkbox" v-model="invoiceItem.is_refund"> Auslage
                    </div>
                </div>
                <div class="pr-4 flex-grow-1">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">Gebühr</label>
                    <input 
                        type="number" 
                        v-model.number="invoiceItem.factor" 
                        step="0.1" 
                        min="0" 
                        class="input w-full" 
                        placeholder="0.00"
                    />
                    <div class="input-error-message" v-if="errors['factor']">{{errors['factor'][0]}}</div>
                    <div class="mt-1">
                      <input type="checkbox" v-model="invoiceItem.use_old_rvg"> RVG alt
                    </div>
                </div>
                <div class="pr-4 flex-grow-2">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">Gegenstandswert</label>
                    <currency-input
                            v-model="invoiceItem.jurisdictional_amount"
                            currency="EUR"
                            locale="de"
                            class="input w-full"
                    />
                    <div class="input-error-message" v-if="errors['jurisdictional_amount']">
                        {{errors['jurisdictional_amount'][0]}}
                    </div>
                </div>
                <div class="pr-4 flex-grow-1">
                    <label class="block text-sm uppercase text-gray-600 mt-2 mb-1">USt %</label>
                    <input type="text" class="input w-full" v-model="invoiceItem.sales_tax_percent"
                           placeholder="USt"/>
                    <div class="input-error-message" v-if="errors['sales_tax_percent']">
                        {{errors['sales_tax_percent'][0]}}
                    </div>
                </div>
                <button v-on:click="save()" class="btn btn-small btn-secondary ml-2 mt-8"><i
                        class="far fa-plus-square"></i> speichern
                </button>
                <button v-on:click="abort()" class="btn btn-small btn-secondary ml-2 mt-8"><i
                        class="far fa-plus-square"></i> abbrechen
                </button>
            </div>
        </template>
        <template v-else>
            <invoice-item
                    v-if="!invoiceItem.hidden"
                    @edit="edit()"
                    @delete="destroy()"
                    :key="invoiceItem.id"
                    :description="invoiceItem.description"
                    :factor="invoiceItem.factor"
                    :jurisdictional_amount="invoiceItem.jurisdictional_amount"
                    :amount="invoiceItem.amount"
                    :sales_tax_percent="invoiceItem.sales_tax_percent"
                    :is_refund="invoiceItem.is_refund"
                    :use_old_rvg="invoiceItem.use_old_rvg"
            >
            </invoice-item>
            <template v-else>
                <div class="px-4 text-gray-600">
                    {{ invoiceItem.description }}
                    <button v-on:click="edit()" class="btn btn-small btn-secondary ml-2"><i
                            class="far fa-plus-square"></i> hinzufügen
                    </button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        components: {},
        props: [
            'initialItem',
            'fixedFields',
            'defaultJurisdictionalAmount'
        ],
        data() {
            return {
                invoiceItem: JSON.parse(JSON.stringify(this.initialItem)),
                editMode: false,
                errors: [],
            }
        },
        methods: {
            saveMethod: function () {
                return 'put';
                // if (this.invoiceItem.template) {
                //     return 'post';
                // } else {
                //     return 'put'
                // }
            },
            saveUrl: function () {
                return '/invoice_rvg_items/' + this.invoiceItem.id;
                // if (this.invoiceItem.template) {
                //     return '/invoice_rvg_items';
                // } else {
                //     return '/invoice_rvg_items/' + this.invoiceItem.id;
                // }
            },
            edit: function () {
                this.editMode = true
                if (this.invoiceItem.jurisdictional_amount == null) {
                    this.invoiceItem.jurisdictional_amount = this.defaultJurisdictionalAmount
                }
                if (this.invoiceItem.sales_tax_percent == null) {
                    this.invoiceItem.sales_tax_percent = 19
                }
                this.$forceUpdate()
            },
            abort: function () {
                this.invoiceItem.factor = this.initialItem.factor
                this.invoiceItem.description = this.initialItem.description
                this.invoiceItem.jurisdictional_amount = this.initialItem.jurisdictional_amount
                this.invoiceItem.sales_tax_percent = this.initialItem.sales_tax_percent
                this.invoiceItem.is_refund = this.initialItem.is_refund
                this.invoiceItem.use_old_rvg = this.initialItem.use_old_rvg
                this.editMode = false
                this.$forceUpdate()
            },
            save: function () {
                this.$http[this.saveMethod()](this.saveUrl(), {
                    invoice_rvg_item: {
                        hidden: false,
                        // invoice_id: this.invoiceItem.invoice_id,
                        factor: this.invoiceItem.factor,
                        description: this.invoiceItem.description,
                        jurisdictional_amount: this.invoiceItem.jurisdictional_amount,
                        sales_tax_percent: this.invoiceItem.sales_tax_percent,
                        is_refund: this.invoiceItem.is_refund,
                        use_old_rvg: this.invoiceItem.use_old_rvg,
                        // section: this.invoiceItem.section,
                        // identifier: this.invoiceItem.identifier,
                    }
                }).then(response => {
                    console.log(response.body)
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    this.$forceUpdate()
                }, response => {
                    // console.log(response)
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
            },
            destroy: function () {
                this.$http['delete']('/invoice_rvg_items/' + this.invoiceItem.id).then(response => {
                    console.log(response.body)
                    this.invoiceItem = response.body
                    this.editMode = false
                    this.errors = []
                    this.$forceUpdate()
                }, response => {
                    // console.log(response)
                    if (response.status = 422) {
                        this.errors = response.body;
                    } else {
                    }
                })
                this.$emit("items-updated", this.invoiceItems)
            }
        },
        mounted: function () {
        }
    }
</script>